/**
 * @generated SignedSource<<f2b2cae22a0edd2db1da6ce892ae4a34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WSSignalOverviewQuery$variables = {
  id: string;
};
export type WSSignalOverviewQuery$data = {
  readonly store: {
    readonly publicTeams: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetOverviewSettings_Store">;
  };
  readonly widgetSignalOverview: {
    readonly id: string;
    readonly teams: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type WSSignalOverviewQuery = {
  response: WSSignalOverviewQuery$data;
  variables: WSSignalOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "WidgetSignalOverview",
  "kind": "LinkedField",
  "name": "widgetSignalOverview",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WSSignalOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetOverviewSettings_Store"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WSSignalOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "43115ca2d1762a5e35d5fbaadc86a2de",
    "id": null,
    "metadata": {},
    "name": "WSSignalOverviewQuery",
    "operationKind": "query",
    "text": "query WSSignalOverviewQuery(\n  $id: ID!\n) {\n  store {\n    ...WidgetOverviewSettings_Store\n    publicTeams {\n      id\n    }\n    id\n  }\n  widgetSignalOverview(id: $id) {\n    id\n    teams {\n      id\n    }\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n\nfragment WidgetOverviewSettings_Store on Store {\n  publicTeams {\n    id\n    ...TeamSelectList_Team\n  }\n}\n"
  }
};
})();

(node as any).hash = "5449bfef096a150ac9efae67c4f3b474";

export default node;
